/**
 * Lazy-Zugriff auf StorageEngine — bricht Zirkel container ↔ kvAccess ↔ Repositories.
 */

/** @type {import('./StorageEngine').StorageEngine|null} */
let engineInstance = null;

/** @param {import('./StorageEngine').StorageEngine} engine */
export function setStorageEngineRef(engine) {
  engineInstance = engine;
}

/**
 * @returns {import('./StorageEngine').StorageEngine}
 */
export function getStorageEngineRef() {
  if (engineInstance) {
    return engineInstance;
  }
  const { getStorageEngine } = require('../../app/di/container');
  engineInstance = getStorageEngine();
  return engineInstance;
}

export function clearStorageEngineRef() {
  engineInstance = null;
}
